import {
  getBluetooth,
  getConnection,
  getIsAutomated,
  getMatchMediaHover,
  getMimeTypes,
  getPlugins,
  getUSB,
  getVibrate,
  getVirtualKeyboard,
} from "./utils";

const navigatorDataToTrack = [
  "platform",
  "vendor",
  "appVersion",
  "language",
  "languages",
  "hardwareConcurrency",
  "deviceMemory",
  "doNotTrack",
  "maxTouchPoints",
  "webdriver",
];

const getNavigatorData = async () => {
  const meta = {};
  try {
    await getBluetooth(meta);
    await getUSB(meta);
    getMimeTypes(meta);
    getConnection(meta);
    getPlugins(meta);
    getVibrate(meta);
    getVirtualKeyboard(meta);
    getMatchMediaHover(meta);
    getIsAutomated(meta);
    for (const propName of navigatorDataToTrack) {
      meta[propName] = window.navigator[propName];
    }
  } catch (error) {
    console.error("Error getting navigator data:", error);
  }
  return meta;
};

export default getNavigatorData;
